import React from 'react'
import { useRouter } from 'next/router'
import { signOut } from 'next-auth/react'

import { Icon, Typography, useTheme } from '@themenu/design-system'

export const BackButton = () => {
  const theme = useTheme()
  const { route } = useRouter()

  async function handleClick() {
    if (route === '/auth/login') {
      return (window.location.href = 'https://www.swile.co/pt-br')
    }

    await signOut({
      callbackUrl: '/auth/login'
    })
  }

  return (
    <Typography
      variant="body"
      component="button"
      className="flex items-center gap-24 text-content-subdued no-underline"
      onClick={handleClick}
    >
      <Icon
        name="chevron-left"
        size={14}
        color={theme.colors.content.subdued}
      />
      {route === '/auth/login'
        ? 'Voltar para o site Swile'
        : 'Voltar para a tela inicial'}
    </Typography>
  )
}
